var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSlectArrows = function SvgSlectArrows(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 7,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.799.228A.65.65 0 0 0 10.312 0a.65.65 0 0 0-.486.228l-4.33 4.894L1.166.228C.991.037.74-.036.506.037a.74.74 0 0 0-.482.544.85.85 0 0 0 .17.746l4.815 5.445A.65.65 0 0 0 5.496 7a.65.65 0 0 0 .486-.228L10.8 1.327A.832.832 0 0 0 11 .777a.832.832 0 0 0-.201-.55Z",
    fill: "#212121",
    fillRule: "nonzero"
  })));
};
export default SvgSlectArrows;